import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Paper,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  Radio,
  FormControl,
  RadioGroup,
  FormControlLabel } from '@material-ui/core';
import _ from 'lodash';
import { toast } from 'react-toastify';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import apiService from '../../../services.js/apiService';
import { IsEmpty } from '../../../common/checks';
import PageSearch from '../../../components/PageSearch';
import { Url, Status, BusinessPlan } from '../../../common/constants';
import OverLoading from '../../../components/global/OverLoading';

function BusinessDetails({ match }) {
  const [pageClaim, setPageClaim] = useState(null);
  const [plan, setPlan] = useState(BusinessPlan.Free);
  const [openModal, setOpenModal] = useState(false);
  const [remarks, setRemark] = useState('');
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const closePageModal = () => setOpenModal(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpen2 = () => {
    setOpen2(true);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  const getPageClaimData =  async () => {
    if (match) {
      try {
        setLoading(true);
        const data =  await apiService.getPageClaimById(match.params.pageClaimId);
        const refinedRemarks = data.pageClaim.remarks ? data.pageClaim.remarks : '';
        const refinedData = {
          pageClaim: {
            claimId:                 data.pageClaim.id,
            pageName:                data.pageClaim.pageName,
            pageId:                  data.pageClaim.pageId,
            newPageName:             data.pageClaim.pageRename ? data.pageClaim.pageRename : '',
            keepTheExistingPageData: data.pageClaim.isKeepData ? 'Yes' : 'No',
            pageType:                data.pageClaim.pageType,
            pageCategories:          data.pageClaim.pageCategories || [],
            status:                  data.pageClaim.status,
            address:                 data.pageClaim.address || '',
            postalCode:              data.pageClaim.postalCode ? data.pageClaim.postalCode : '',
            requestDate:             data.pageClaim.requestDate || '',
          },
          businessProfile: {
            companyName:        data.businessProfile.name || '',
            AcraRegistrationNo: data.businessProfile.regNo || '',
            companyAddress:     data.businessProfile.address || '',
            contactPerson:      data.businessProfile.contactPerson || '',
            contactEmail:       data.businessProfile.contactEmail || '',
            contactPhoneNumber: data.businessProfile.contactNo || '',
            verifiedDate:       data.businessProfile.verifiedDate || '',
          },
          businessUser: data.businessUser,
        };
        setPageClaim(refinedData);
        setRemark(refinedRemarks);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    getPageClaimData();
  }, []);

  const handleInputChange = (name, value) => {
    setPageClaim((prevState) => ({
      ...prevState,
      pageClaim: { ...prevState.pageClaim, [name]: value },
    }));
  };

  const handleChangeRemark = (e) => {
    setRemark(e.target.value);
  };

  const handleSubmitAccept =  async () => {
    //check pageId is valid
    if (pageClaim.pageClaim.pageId) {
      try {
        setLoading(true);
        await apiService.updatePageClaim(pageClaim.pageClaim.claimId, {
          claimStatus: 'Live',
          pageId:      pageClaim.pageClaim.pageId,
          plan,
        });
        toast.success('Claim Accepted');
        history.push(`${Url.Business}`);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    } else {
      toast.error('Page ID is invalid');
    }
  };

  const handleSubmitReject =  async () => {
    //check remark
    if (IsEmpty(remarks)) {
      toast.error('Please add remark for reject reason');
    } else {
      try {
        setLoading(true);
        await apiService.updatePageClaim(pageClaim.pageClaim.claimId, {
          claimStatus: 'Rejected',
          remarks,
        });
        toast.success('Claim Rejected');
        history.push(`${Url.Business}`);
      } catch (error) {
        toast.error(error);
      } finally {
        setLoading(false);
      }
    }
  };

  const populatePage = (result) => {
    handleInputChange('pageId', result.pageId);
    handleInputChange('pageName', result.pageName);
  };

  const renderPageClaimInfo = () => {
    if (pageClaim) {
      return Object.entries(pageClaim.pageClaim).map((item, index) => {
        // exclude pageCategories here
        if (item[0] !== 'pageCategories') {
          let refinedString = '';
          let refinedval = item[1];
          const titleArr = item[0].match(/[A-Z]*[^A-Z]+/g);
          titleArr.forEach((title) => {
            refinedString = `${refinedString} ${title}`;
          });

          if (item[0] === 'requestDate' || item[0] === 'verifiedDate') {
            const dateObj = new Date(item[1].toLocaleString('en-US', { timeZone: 'Asia/Singapore' }));
            const formatted = moment(dateObj).format('DD/MM/YYYY');
            refinedval = formatted;
          }

          return (
            <ul className="list-group list-group-flush" key={index}>
              <li className="my-1 py-1 list-group-item d-flex justify-content-between">
                <Typography
                  variant="body1"
                  className="font-weight-bold"
                  style={{
                    textTransform: 'capitalize',
                  }}
                >
                  {refinedString}
                  {' '}
                  :
                </Typography>
                <Typography variant="body1">{refinedval}</Typography>
              </li>
            </ul>
          );
        }
      });
    }
  };

  const renderBusinessProfileInfo = () => {
    if (pageClaim) {
      return Object.entries(pageClaim.businessProfile).map((item, index) => {
        let refinedString = '';
        let refinedval = item[1];
        const titleArr = item[0].match(/[A-Z]*[^A-Z]+/g);
        titleArr.forEach((title) => {
          refinedString = `${refinedString} ${title}`;
        });

        if (item[0] === 'requestDate' || item[0] === 'verifiedDate') {
          // check value is not null - some businessProfiles don't have verifiedDate value
          if (item[1]) {
            const dateObj = new Date(item[1].toLocaleString('en-US', { timeZone: 'Asia/Singapore' }));
            const formatted = moment(dateObj).format('DD/MM/YYYY');
            refinedval = formatted;
          } else {
            refinedval = '';
          }
        }

        return (
          <ul className="list-group list-group-flush" key={index}>
            <li className="my-1 py-1 list-group-item d-flex justify-content-between">
              <Typography
                variant="body1"
                className="font-weight-bold"
                style={{
                  textTransform: 'capitalize',
                }}
              >
                {refinedString}
                {' '}
                :
              </Typography>
              <Typography variant="body1">{refinedval}</Typography>
            </li>
          </ul>
        );
      });
    }
  };

  const renderBusinessUserInfo = () => {
    if (pageClaim && pageClaim.businessUser) {
      return (
        <ul className="list-group list-group-flush">
          <li className="my-1 py-1 list-group-item d-flex justify-content-between">
            <Typography
              variant="body1"
              className="font-weight-bold"
              style={{
                textTransform: 'capitalize',
              }}
            >
              Id
              {' '}
              :
            </Typography>
            <Typography variant="body1">{pageClaim.businessUser.id}</Typography>
          </li>
          <li className="my-1 py-1 list-group-item d-flex justify-content-between">
            <Typography
              variant="body1"
              className="font-weight-bold"
              style={{
                textTransform: 'capitalize',
              }}
            >
              Name
              {' '}
              :
            </Typography>
            <Typography variant="body1">{pageClaim.businessUser.name}</Typography>
          </li>
          <li className="my-1 py-1 list-group-item d-flex justify-content-between">
            <Typography
              variant="body1"
              className="font-weight-bold"
              style={{
                textTransform: 'capitalize',
              }}
            >
              Email
              {' '}
              :
            </Typography>
            <Typography variant="body1">{pageClaim.businessUser.email}</Typography>
          </li>
        </ul>
      );
    }
  };

  const renderProcessClaim = () => {
    if (pageClaim) {
      return (
        <>
          <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
          >
            <DialogTitle id="alert-dialog-title" className="mx-4 mt-3">Accept page claim</DialogTitle>
            <DialogActions className="mb-3 mr-3">
              <Button onClick={handleClose} variant="contained" color="inherit">
                cancel
              </Button>
              <Button className="ml-4" onClick={handleSubmitAccept} variant="contained" color="primary" autoFocus disabled={loading}>
                Accept
              </Button>
            </DialogActions>

          </Dialog>
          <Dialog
            open={open2}
            onClose={handleClose2}
          >
            <DialogTitle id="alert-dialog-title" className="px-5">Reject Page Claim</DialogTitle>
            <DialogContent className="px-5">
              <div className="container p-0 m-0">
                <Typography variant="body1">
                  Add reason for rejecting claim (This will be shared with the business user)
                </Typography>
                <TextField
                  id="standard-multiline-static"
                  className="w-100 mt-2"
                  variant="outlined"
                  multiline
                  rows={4}
                  onChange={handleChangeRemark}
                />
              </div>

            </DialogContent>
            <DialogActions className="mb-3 mx-4">
              <Button onClick={handleClose2} variant="contained" color="inherit">
                cancel
              </Button>
              <Button className="ml-4" onClick={handleSubmitReject} variant="contained" color="secondary" autoFocus disabled={loading}>
                Reject
              </Button>
            </DialogActions>
          </Dialog>
          <div>
            <div className="d-flex flex-row justify-content-between mt-3">
              <Typography
                variant="h6"
                className="font-weight-bold mx-2"
              >
                Page to link
              </Typography>
              <Button
                className="ml-3"
                size="small"
                variant="contained"
                color="inherit"
                onClick={() => { setOpenModal(true); }}
                disabled={pageClaim.pageClaim.status !== Status.Pending}
              >
                <Typography variant="body1">Set/Update</Typography>
              </Button>
            </div>
            <ul className="list-group list-group-flush my-1">
              <li className="my-2 py-2 list-group-item d-flex justify-content-between">
                <Typography
                  variant="body1"
                  className="font-weight-bold"
                >
                  Page Name :
                </Typography>
                <Typography variant="body1">{pageClaim.pageClaim.pageName}</Typography>
              </li>
              <li className="my-2 py-2 list-group-item d-flex justify-content-between">
                <Typography
                  variant="body1"
                  className="font-weight-bold"
                >
                  Page ID :
                </Typography>
                <Typography variant="body1">{pageClaim.pageClaim.pageId}</Typography>
              </li>
              {
                pageClaim.pageClaim.status === Status.Pending && (
                  <li
                    className="my-2 py-2 list-group-item d-fle flex-column"
                    style={{
                      listStyle: 'none',
                    }}
                  >
                    <Typography
                      variant="body1"
                      className="font-weight-bold"
                    >
                      Plan :
                    </Typography>
                    <FormControl component="fieldset">
                      <RadioGroup
                        aria-label="businessPlan"
                        row
                        name="Business Plan"
                        value={plan}
                        onChange={(e) => setPlan(e.target.value)}
                      >
                        <FormControlLabel value={BusinessPlan.Free} control={<Radio size="small" />} label={BusinessPlan.Free} />
                        <FormControlLabel value={BusinessPlan.Premium} control={<Radio size="small" />} label={BusinessPlan.Premium} />
                        <FormControlLabel value={BusinessPlan.Ultimate} control={<Radio size="small" />} label={BusinessPlan.Ultimate} />
                      </RadioGroup>
                    </FormControl>
                  </li>
                )
              }
            </ul>
            {
              pageClaim.pageClaim.status === Status.Pending && (
                <div className="d-flex flex-row justify-content-end my-2">
                  <Button className="m-2" color="secondary" variant="contained" onClick={handleClickOpen2} disabled={loading}>Reject</Button>
                  <Button className="m-2 ml-4" color="primary" variant="contained" onClick={handleClickOpen} disabled={!pageClaim.pageClaim.pageId || loading}>Accept</Button>
                </div>
              )
            }

          </div>
        </>
      );
    }
  };

  const RenderPageCategories = () => {
    if (pageClaim && pageClaim.pageClaim.pageCategories.length > 0) {
      const pageGroupCategories = [...new Set(pageClaim.pageClaim.pageCategories.map((el) => el.group))];
      const pageCategories = pageGroupCategories.map((el, index) => {
        const curMembersGroupCategory = pageClaim.pageClaim.pageCategories.filter((cur) => cur.group === el).map((cat) => cat.name);
        return (
          <li className="d-flex flex-column" key={el} style={{ marginTop: index === 0 ? '0' : '1rem' }}>
            <Typography variant="body1" display="inline" style={{ fontWeight: 'bold' }}>{el}</Typography>
            <div className="d-flex flex-column justify-content-start">
              {
                _.map(curMembersGroupCategory, (categoryName) => (
                  <Typography variant="body1" key={categoryName}>
                    {categoryName}
                  </Typography>
                ))
              }
            </div>
          </li>
        );
      });
      return (
        <ul style={{
          listStyleType: 'none',
          margin:        0,
          padding:       0,
        }}
        >
          {pageCategories}
        </ul>
      );
    } else {
      return (
        <div>
          {' '}
          <Typography variant="body1"> No Categories for this page claim. </Typography>
          {' '}
        </div>
      );
    }
  };

  return (
    <>
      {openModal && <PageSearch onCancel={closePageModal} onDone={(e) => populatePage(e)} />}
      {loading && <OverLoading />}
      <div className="content-header">
        <h1>Business Details</h1>
      </div>
      <div className="container-fluid">
        <div className="row">
          <Button className="py-3" variant="text" color="inherit" href={Url.Business}>
            <div className="d-flex flex-row">
              <Icon>arrow_back</Icon>
              <Typography className="ml-2" variant="body1">Back</Typography>
            </div>
          </Button>
        </div>
        <div className="row my-2">
          <Paper className="col-md-6 col-lg-6 col-sm-12 p-2 mt-2 text-center">
            <Typography variant="h6" className="font-weight-bold my-3">Page Claim Info</Typography>
            {renderPageClaimInfo()}
          </Paper>
          <Paper className="col-md-6 col-lg-6 col-sm-12 p-2 mt-2 text-center">
            <Typography variant="h6" className="font-weight-bold my-3">Business Profile Info</Typography>
            {renderBusinessProfileInfo()}
          </Paper>
        </div>
        <div className="row">
          <Paper className="p-3 my-4 col-sm-12 col-md-6 col-lg-6">
            <Typography variant="h6" className="font-weight-bold my-3">Page Categories</Typography>
            {RenderPageCategories()}
          </Paper>
          <Paper className="p-3 my-4 col-sm-12 col-md-6 col-lg-6">
            <Typography variant="h6" className="font-weight-bold my-3 text-center">
              Business User Info
              <br />
              who submitted the page claim
            </Typography>
            {renderBusinessUserInfo()}
          </Paper>
        </div>
        <div className="row d-flex flex-column align-items-center">
          <Paper className="p-3 my-4 col-sm-12 col-md-8 col-lg-6">
            <Typography variant="h5" className="font-weight-bold my-2">Process Claim</Typography>
            {renderProcessClaim()}
          </Paper>
        </div>
      </div>
    </>
  );
}

BusinessDetails.propTypes = {
  match: PropTypes.shape({
    isExact: PropTypes.bool,
    path:    PropTypes.string,
    url:     PropTypes.string,
    params:  PropTypes.shape({
      pageClaimId: PropTypes.string,
    }),
  }).isRequired,
};

export default BusinessDetails;
